// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"b5869db6","622":"1c6918e3","976":"1c6918e3"}[chunkId] + ".chunk.css";
};